import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for NavigationStore, for use in the registry */ export const NavigationStoreActionTypes = [
    ActionType.EnqueuePlanPostCreateNavigation,
    ActionType.EnqueuePortfolioPostCreateNavigation,
    ActionType.NavigateToView
];
